import React from 'react';
import { Box, Typography } from '@mui/material';
import WeltiTimelyLoader from '../WeltiTimelyLoader/WeltiTimelyLoader';

interface PageLoaderProps {
  /** Optionaler Kontext-Text unter dem Loader */
  message?: string;
}

/**
 * Ganzseiten-Loader für React.lazy Suspense-Fallback und initiale Seiten-Loads.
 * Verwendet den gebrandeten WeltiTimelyLoader.
 */
const PageLoader: React.FC<PageLoaderProps> = ({ message }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    minHeight="60vh"
    gap={2}
  >
    <WeltiTimelyLoader />
    {message && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        {message}
      </Typography>
    )}
  </Box>
);

export default PageLoader;
